import { BalanceSheetCategoryType } from '@/types/schema';

/**
 * Balance sheet category types that should be hidden from user-facing
 * asset category selectors. These categories exist for integration mapping
 * but should not appear in manual add/edit flows.
 */
export const HIDDEN_BALANCE_SHEET_CATEGORY_TYPES = new Set([
  BalanceSheetCategoryType.Liabilities,
  BalanceSheetCategoryType.Receivables,
]);
